import { render, staticRenderFns } from "./BriqPanel.vue?vue&type=template&id=45f789d8&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./BriqPanel.vue?vue&type=style&index=0&id=45f789d8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "45f789d8",
  null
  
)

export default component.exports